import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux';

import { appActions } from './core/app';
import configureStore from './core/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from './views/App';
import * as serviceWorker from './serviceWorker';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

const store = configureStore();

store.dispatch(appActions.initApp({
  check_session: true
}));

console.error = (function (original) {
  return function (...args) {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('defaultProps will be removed from function components') // reactstrap warning ignore temporarily
    ) {
      return;
    }
    original.apply(console, args);
  };
})(console.error);

const shouldRedirect = window.location.pathname === '/' || window.location.pathname === '';
if (shouldRedirect) {
  const rawPublicUrl = process.env.PUBLIC_URL || '';
  let basePath = '';
  try {
    const parsed = new URL(rawPublicUrl, window.location.origin);
    basePath = parsed.pathname.replace(/\/$/, '');
  } catch (e) {
    basePath = (rawPublicUrl || '').replace(/\/$/, '');
  }
  const target = `${basePath ? basePath : ''}/welcome`;
  const targetSearch = window.location.search || '';
  const fullTarget = `${target}${targetSearch}`;
  window.location.replace(fullTarget);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </Provider>
  );
}